import { render, staticRenderFns } from "./AccountSetting.vue?vue&type=template&id=0be77866&scoped=true&"
import script from "./AccountSetting.vue?vue&type=script&lang=ts&"
export * from "./AccountSetting.vue?vue&type=script&lang=ts&"
import style1 from "./AccountSetting.vue?vue&type=style&index=1&id=0be77866&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be77866",
  null
  
)

export default component.exports